import type { BoxProps } from '@withjoy/joykit';
import type { HeaderBackgroundEffect } from '@shared/types/WebsiteHeaderSettings.types';
import chroma from 'chroma-js';

/**
 * Maps a {@link HeaderBackgroundEffect} value to Joykit `BoxProps` that render
 * the corresponding visual treatment (glass blur, semi-transparent fill, etc.).
 *
 * Shared between the guest site header and the admin template thumbnail so both
 * render identical effects for the same settings.
 */
export const getBackgroundEffectStyles = (effect: HeaderBackgroundEffect | undefined, backgroundColor?: string): BoxProps => {
  if (!effect) {
    return {};
  }

  const map: Record<HeaderBackgroundEffect, BoxProps> = {
    clear: {
      backgroundColor: 'transparent',
    },
    glass: {
      backgroundColor: 'rgba(255, 255, 255, 0.29)',
      borderRadius: '16px',
      boxShadow: '0 4px 30px rgba(0, 0, 0, 0.1)',
      backdropFilter: 'blur(5.6px)',
      border: '1px solid rgba(255, 255, 255, 0.26)',
    },
    transparent: {
      backgroundColor: chroma(backgroundColor || '#ffffff')
        .alpha(0.1)
        .hex(),
    },
    solid: {
      backgroundColor,
    },
  };

  return map[effect];
};
